import styled from 'styled-components'

export const BurgerNav = styled.nav`
  position: fixed;
  width: 100%;
  height: calc(100% - 76px);
  overflow: hidden;
  background-color: ${props => props.theme.colors.greyscale.white};
`

export const BurgerHeader = styled.header`
  background-color: ${props => props.theme.colors.primary.base}
  background: ${props => props.theme.colors.primary.gradient}
`

export const BurgerTitle = styled.div`
  font-size: ${({size}) => (size === 'big' ? '18px' : '12px')};
  line-height: 1;
  font-weight: bold;
  padding: ${({position}) => (position === 'bottom' ? '5px 25px 10px' : '10px 25px 5px')};
  color: ${props => props.theme.colors.greyscale.white};
`

export const BurgerPrevPanelButton = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  font-size: ${({size}) => (size === 'big' ? '18px' : '12px')};
  line-height: 1;
  font-weight: bold;
  padding: 10px 25px 5px 16px;
  color: ${props => props.theme.colors.greyscale.white};
  border: 0;
  width: 100%;
  text-align: left;
  
  &:hover {
    cursor: pointer;
  }
`

export const BurgerMainLink = styled.a`
  display: block;
  font-size: 18px;
  line-height: 1;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  padding: 5px 25px 10px;
  color: ${props => props.theme.colors.greyscale.white};
  margin: 0;
  
  &:hover {
    cursor: pointer;
  }
`

export const BurgerPanelsWrapper = styled.div`
  display: flex;
  align-items: stretch;
  flex-wrap: nowrap;
  justify-content: flex-start; 
  overflow: hidden;
  height: calc(100% - ${({hasMultilanguage}) => (hasMultilanguage ? '116px' : '60px')});
  position: relative;
  transition: left .3s ease-in-out;
`

export const BurgerPanel = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  overflow-y: auto;
`

export const BurgerItem = styled.li`
  position: relative;
  border-bottom: 1px solid ${props => props.theme.colors.greyscale.light};
`

export const BurgerItemLink = styled.a`
  display: block;
  padding: 0 25px;
  font-size: 14px;
  line-height: 56px;
  text-decoration: none;
  color: ${({theme, isSpecial}) => (isSpecial ? '#c00' : theme.colors.primary.base)};
`

export const BurgerItemButton = styled.button`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  border: 0;
  background: transparent;
  font-weight: bold;
  font-size: 14px;  
  text-decoration: none;
  color: ${props => props.theme.colors.primary.base};
  
  &:hover {
    cursor: pointer;
  } 
`
